import { Button, Flex, Grid, TextInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { useRef } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import Modal from '@/components/modal/Modal';
import TabContent from '@/components/TabContent';
import { TAgent, useAddAgent } from '@/models/agents';
import AgentDetails from './AgentDetails';
import AgentList from './AgentsList';

export function AgentsPage() {
  const [opened, { open, close }] = useDisclosure(false);
  const addAgent = useAddAgent();
  const nameRef = useRef<HTMLInputElement>(null);
  const [, nav] = useLocation();
  return (
    <>
      <Modal title="Add new agent" opened={opened} onClose={close} size={'xs'}>
        <Flex p={'xs'} direction={'column'} gap={'lg'}>
          <TextInput
            flex={1}
            label="Name"
            description="The name of the agent"
            placeholder="Jon Snow; Supreme Court of Poland"
            ref={nameRef}
          />
          <Button
            size={'xs'}
            variant="light"
            onClick={() =>
              addAgent.mutate(nameRef.current?.value ?? '', {
                onSuccess: (addedAgent: TAgent) => {
                  nav(`/${addedAgent.id}`, {
                    state: { agent: addedAgent },
                  });
                  notifications.show({
                    title: 'Agent added',
                    message: `Agent ${addedAgent.name} added successfully`,
                    color: 'green',
                    position: 'top-right',
                  });
                },
                onSettled: close,
              })
            }
          >
            Add
          </Button>
        </Flex>
      </Modal>
      <TabContent
        rightSection={
          <Button size={'xs'} variant="light" onClick={open}>
            Add new agent
          </Button>
        }
      >
        <Grid gap={0}>
          <Grid.Col span={4}>
            <AgentList />
          </Grid.Col>
          <Switch>
            <Route path={'/:id'} component={AgentDetails} />
          </Switch>
        </Grid>
      </TabContent>
    </>
  );
}
